<template>
  <base-site-loader type="publish" />
</template>

<script>
import { captureException } from '@sentry/browser';
import { sitePrepareRequest } from '@/services/sitePrepareRequest';
import store from '@/store';

const DEFAULT_ERROR_KEY = 'errors.default';

export default {
  props: {
    data: Object,
  },
  methods: {
    async publishSite(sourceData) {
      try {
        await sitePrepareRequest(sourceData);
        this.goToSiteSuccess();
      } catch (error) {
        this.handleRequestError(error);
      }
    },
    handleRequestError(error) {
      if (error && error.name) {
        this.showError(error.name);
        captureException(error);
        return;
      }
    },
    showError(key) {
      if (this.$i18n) {
        const errorKey = this.$te(`errors.${key}`) ? `errors.${key}` : DEFAULT_ERROR_KEY;
        this.$showError(this.$t(errorKey));
      }

      this.goToSiteSuccess();
    },
    goToPayment() {
      this.$router.go(-1);
    },
    goToSiteSuccess() {
      this.$router.push('/success');
    },
  },
  mounted() {
    if (!store.jwt) {
      this.$router.push('/');
      return;
    }

    this.publishSite(store.jwt);
  },
};
</script>
